var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-plan-editor-vpcs-needed"},[_c('span',[_vm._v(_vm._s(_vm.formatMessage(_vm.lessonPlanLocale.LessonPlanMasterPlanLessonPlanEditorVPCNeededTitle)))]),_vm._v(_vm._s(_vm.vpcNeededs)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }